import React from "react";
import { Field, FastField } from "formik";
import get from "lodash.get";
import Dropdown from "../../../../../ui/widgets/dropdown";
import { DropdownFieldPropsType, DropdownWrapperPropsType } from "./types";
import { SelectChangeEvent } from "@mui/material";

const DropdownWrapper = ({ field, ...props }: DropdownWrapperPropsType) => {
  const {
    label,
    menuItems,
    dropdownInputProps,
    selectedItemValue,
    onSelectCallback,
    disabled,
  } = props;

  const error = get(props, `form.errors.${field.name}`);
  const touched = get(props, `form.touched.${field.name}`);

  const handleOnSelect = (e: SelectChangeEvent<string | number | string[]>) => {
    field.onChange({
      target: {
        value: e.target.value,
        name: field.name,
      },
    });
    if (onSelectCallback) {
      onSelectCallback(e);
    }
  };

  const onBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    field.onBlur({
      target: {
        value: e.target.value,
        name: field.name,
      },
    });
  };

  return (
    <Dropdown
      descriptionText={props.descriptionText}
      id={field.name}
      label={label}
      menuItems={menuItems}
      dropdownInputProps={dropdownInputProps}
      onSelect={handleOnSelect}
      onBlur={onBlur}
      selectedItemValue={selectedItemValue}
      disabled={disabled}
      error={!!error && touched}
      errorText={touched && error}
    />
  );
};

export default function DropdownField(
  props: DropdownFieldPropsType,
): React.JSX.Element {
  return props.forceReRender ? (
    <Field component={DropdownWrapper} {...props} />
  ) : (
    <FastField component={DropdownWrapper} {...props} />
  );
}
